(function () {
  'use strict';

  if (window.__ECOMIFIC_REGION_VISIBILITY__) {
    return;
  }
  window.__ECOMIFIC_REGION_VISIBILITY__ = true;

  var CARD_SELECTOR = '[data-ecomific-product-card]';
  var HIDDEN_CLASS = 'ecomific-hidden-by-region';
  var REGION_COOKIE = 'ecomific_region';
  var REGION_LS_KEY = 'ecomific_region';
  var MUTATION_DEBOUNCE_MS = 80;
  var pendingNodes = [];
  var applyTimer = null;
  var observer = null;
  var initialized = false;
  var cachedRegion = '';

  function normalizeRegion(value) {
    if (typeof value !== 'string') {
      return '';
    }
    var normalized = value.trim().toLowerCase();
    return normalized === 'east' || normalized === 'west' ? normalized : '';
  }

  function isThemePreview() {
    try {
      if (window.Shopify && window.Shopify.designMode) return true;
      try {
        return sessionStorage.getItem('ecomific_theme_preview') === '1';
      } catch (e) {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  function getCookie(name) {
    if (typeof document === 'undefined' || !name) {
      return '';
    }
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getRegionFromStorage() {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        var ls = window.localStorage.getItem(REGION_LS_KEY);
        if (ls) return normalizeRegion(ls);
      }
    } catch (e) {}
    return normalizeRegion(getCookie(REGION_COOKIE));
  }

  function currentRegion() {
    if (cachedRegion === 'east' || cachedRegion === 'west') {
      return cachedRegion;
    }
    return getRegionFromStorage();
  }

  function hasKnownRegion() {
    var r = currentRegion();
    return r === 'east' || r === 'west';
  }

  function nodeMatchesCard(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }
    var fn =
      node.matches ||
      node.matchesSelector ||
      node.msMatchesSelector ||
      node.webkitMatchesSelector ||
      node.mozMatchesSelector;
    if (fn) {
      try {
        return fn.call(node, CARD_SELECTOR);
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  function nodeContainsCard(node) {
    if (!node) {
      return false;
    }
    if (nodeMatchesCard(node)) {
      return true;
    }
    if (node.querySelector) {
      try {
        return node.querySelector(CARD_SELECTOR) !== null;
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  function shouldHideCard(card, region) {
    if (!card || typeof card.hasAttribute !== 'function') {
      return false;
    }
  
    if (card.hasAttribute('data-ecomific-dev-product') && !isThemePreview()) {
      return true;
    }
  
    if (!region) {
      return false;
    }
  
    if (region === 'east') {
      return card.hasAttribute('data-ecomific-west-only');
    }
  
    if (region === 'west') {
      return card.hasAttribute('data-ecomific-east-only');
    }
  
    return false;
  }  

  function hideCard(card) {
    if (!card || !card.classList) {
      return;
    }
    if (!card.classList.contains(HIDDEN_CLASS)) {
      card.classList.add(HIDDEN_CLASS);
    }
    card.setAttribute('aria-hidden', 'true');
  }

  function showCard(card) {
    if (!card || !card.classList) {
      return;
    }
    if (card.classList.contains(HIDDEN_CLASS)) {
      card.classList.remove(HIDDEN_CLASS);
    }
    if (card.getAttribute && card.getAttribute('aria-hidden') === 'true') {
      card.removeAttribute('aria-hidden');
    }
  }

  function cardsInRoot(root) {
    if (!root || root === document) {
      return document.querySelectorAll ? document.querySelectorAll(CARD_SELECTOR) : [];
    }

    if (nodeMatchesCard(root)) {
      return [root];
    }

    if (root.querySelectorAll) {
      try {
        return root.querySelectorAll(CARD_SELECTOR);
      } catch (error) {
        return [];
      }
    }

    return [];
  }

  function applyRegionFilter(root) {
    var targetRegion = currentRegion();
    var cards = cardsInRoot(root);
    if (!cards || !cards.length) {
      return;
    }

    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      if (shouldHideCard(card, targetRegion)) {
        hideCard(card);
      } else {
        showCard(card);
      }
    }
  }

  function queueApply(node) {
    var target = node || document;
    if (target.nodeType && target.nodeType !== 1 && target.nodeType !== 9 && target.nodeType !== 11) {
      target = target.parentElement || document;
    }

    if (pendingNodes.indexOf(target) === -1) {
      pendingNodes.push(target);
    }

    if (applyTimer) {
      return;
    }

    applyTimer = setTimeout(function () {
      var toProcess = pendingNodes.slice();
      pendingNodes.length = 0;
      applyTimer = null;
      for (var i = 0; i < toProcess.length; i += 1) {
        applyRegionFilter(toProcess[i]);
      }
    }, MUTATION_DEBOUNCE_MS);
  }

  function handleMutations(mutations) {
    if (!mutations || !mutations.length) {
      return;
    }
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (!mutation.addedNodes || !mutation.addedNodes.length) {
        continue;
      }
      for (var j = 0; j < mutation.addedNodes.length; j += 1) {
        var node = mutation.addedNodes[j];
        if (nodeContainsCard(node)) {
          queueApply(node);
          break;
        }
      }
    }
  }

  function initObserver() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    if (!document.body) {
      return;
    }
    observer = new MutationObserver(handleMutations);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function onReady() {
    if (initialized) {
      return;
    }
    initialized = true;
    if (!hasKnownRegion()) {
      document.documentElement.classList.add('ecomific-region-pending');
      setTimeout(function () {
        if (!hasKnownRegion()) {
          document.documentElement.classList.remove('ecomific-region-pending');
        }
      }, 800);
    } else {
      document.documentElement.classList.remove('ecomific-region-pending');
      applyRegionFilter();
    }
    initObserver();
  }

  function resolveRootFromEvent(event) {
    if (event && event.detail && event.detail.root && typeof event.detail.root.querySelectorAll === 'function') {
      return event.detail.root;
    }
    if (event && event.target && typeof event.target.querySelectorAll === 'function') {
      return event.target;
    }
    return document;
  }

  window.addEventListener('ecomific:region:ready', function (event) {
    var detail = (event && event.detail) || {};
    if (detail.region) cachedRegion = normalizeRegion(detail.region) || cachedRegion;
    document.documentElement.classList.remove('ecomific-region-pending');
    applyRegionFilter(resolveRootFromEvent(event));
  });

  window.addEventListener('ecomific:region:changed', function (event) {
    var detail = (event && event.detail) || {};
    if (detail.region) cachedRegion = normalizeRegion(detail.region) || cachedRegion;
    document.documentElement.classList.remove('ecomific-region-pending');
    applyRegionFilter(resolveRootFromEvent(event));
  });

  document.addEventListener('shopify:section:load', function (event) {
    applyRegionFilter(event && event.target ? event.target : document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    onReady();
  });

  if (document.readyState !== 'loading') {
    onReady();
  }

  window.ecomificRegionVisibility = {
    apply: applyRegionFilter,
    shouldHideCard: shouldHideCard,
  };
})();

